
import React from 'react';

const SeventhStep = ({ setStep, isKycFailed, isBankVerificationFailed }) => {
  return (
    <div className="py-3 flex flex-col justify-center items-center text-center">
      {isKycFailed && (
        <div className="flex flex-col items-center p-4 text-center">
          <p className="text-gray-800 text-lg mb-1">Facing issues with eKYC?</p>
          <a
            href="/myprofile/docs"
            className="text-blue-600 font-semibold underline cursor-pointer"
          >
            Upload documents manually
          </a>
        </div>
      )}
      {isBankVerificationFailed && (
        <div className="flex flex-col items-center text-center">
        
          <p className="text-gray-800 text-lg mb-1">Facing issues with bank verification?</p>
          <a
            href="/myprofile/docs"
            className="text-blue-600 font-semibold underline cursor-pointer"
          >
            Upload documents manually
          </a>
        </div>
      )}
    </div>
  );
};

export default SeventhStep;
